import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-fit-to-screen.tsx
/**
* icon.24.fit.to.screen
*
* Keywords: arrows, expand, outward, maximize, fullscreen, diagonal, corners, resize
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNi41IDdoMTFhLjUuNSAwIDAgMSAuNS41djlhLjUuNSAwIDAgMS0uNS41aC0xMWEuNS41IDAgMCAxLS41LS41di05YS41LjUgMCAwIDEgLjUtLjVNNSA3LjVBMS41IDEuNSAwIDAgMSA2LjUgNmgxMUExLjUgMS41IDAgMCAxIDE5IDcuNXY5YTEuNSAxLjUgMCAwIDEtMS41IDEuNWgtMTFBMS41IDEuNSAwIDAgMSA1IDE2LjV6bTcuMzU0LjY0NmEuNS41IDAgMCAwLS43MDggMGwtMSAxYS41LjUgMCAwIDAgLjcwOC43MDhsLjE0Ni0uMTQ3VjExLjVIOC43MDdsLjE0Ny0uMTQ2YS41LjUgMCAwIDAtLjcwOC0uNzA4bC0xIDFhLjUuNSAwIDAgMCAwIC43MDhsMSAxYS41LjUgMCAwIDAgLjcwOC0uNzA4bC0uMTQ3LS4xNDZIMTEuNXYxLjc5M2wtLjE0Ni0uMTQ3YS41LjUgMCAwIDAtLjcwOC43MDhsMSAxYS41LjUgMCAwIDAgLjcwOCAwbDEtMWEuNS41IDAgMCAwLS43MDgtLjcwOGwtLjE0Ni4xNDdWMTIuNWgyLjc5M2wtLjE0Ny4xNDZhLjUuNSAwIDAgMCAuNzA4LjcwOGwxLTFhLjUuNSAwIDAgMCAwLS43MDhsLTEtMWEuNS41IDAgMCAwLS43MDguNzA4bC4xNDcuMTQ2SDEyLjVWOS43MDdsLjE0Ni4xNDdhLjUuNSAwIDAgMCAuNzA4LS43MDh6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-10231
*/
const Icon24FitToScreen = memo(function Icon24FitToScreen(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M6.5 7h11a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5M5 7.5A1.5 1.5 0 0 1 6.5 6h11A1.5 1.5 0 0 1 19 7.5v9a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 5 16.5zm7.354.646a.5.5 0 0 0-.708 0l-1 1a.5.5 0 0 0 .708.708l.146-.147V11.5H8.707l.147-.146a.5.5 0 0 0-.708-.708l-1 1a.5.5 0 0 0 0 .708l1 1a.5.5 0 0 0 .708-.708l-.147-.146H11.5v1.793l-.146-.147a.5.5 0 0 0-.708.708l1 1a.5.5 0 0 0 .708 0l1-1a.5.5 0 0 0-.708-.708l-.146.147V12.5h2.793l-.147.146a.5.5 0 0 0 .708.708l1-1a.5.5 0 0 0 0-.708l-1-1a.5.5 0 0 0-.708.708l.147.146H12.5V9.707l.146.147a.5.5 0 0 0 .708-.708z",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24FitToScreen };

//# sourceMappingURL=icon-24-fit-to-screen.js.map